import { ContactCardBodyMediumLink, ContactCardItemContainer } from './styles';
import React from 'react';
import PhoneIcon from '@mui/icons-material/Phone';

type Props = {
    phoneNumber: string;
};

export const ContactCardPhoneItem = ({ phoneNumber }: Props) => {
    return (
        <ContactCardItemContainer>
            <PhoneIcon />
            <ContactCardBodyMediumLink href={'tel:' + phoneNumber}>
                {phoneNumber}
            </ContactCardBodyMediumLink>
        </ContactCardItemContainer>
    );
};
